import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_3 = { class: "flex align-items-center" }
const _hoisted_4 = { class: "text-xs mr-s1" }

import { useI18n } from 'vue-i18n';
import TokenGroupIcon from '@/components/token/TokenGroupIcon.vue';
import networks from '@/helpers/networks';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenChainAvailable',
  props: {
    chainList: null,
    asLine: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  chainList: number[] | string[];
  asLine?: boolean;
}

const { t } = useI18n();


const availableChains = () => {
  let chains: Record<string, unknown>[] = [];
  props.chainList.forEach(chainId => {
    if (networks[chainId] !== undefined) {
      chains.push({ iconLink: networks[chainId].iconLink, symbol: networks[chainId].name });
    }
  });
  return chains;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.asLine ? 'flex inline align-items-baseline gutter-x-s1' : 'gutter-y-s1')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(_toDisplayString(_unref(t)('portfolio.notAvailable')) + ".", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('portfolio.availableOn')), 1),
      _createVNode(TokenGroupIcon, {
        tokens: availableChains(),
        size: "12"
      }, null, 8, ["tokens"])
    ])
  ], 2))
}
}

})